import { toast } from "sonner";

export async function copyToClipboard(text: string, label = "コピーしました"): Promise<void> {
  try {
    await navigator.clipboard.writeText(text);
    toast.success(label, { description: text, duration: 2000 });
  } catch (err) {
    toast.error("コピーに失敗しました", {
      description: err instanceof Error ? err.message : String(err),
    });
  }
}
